exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NewArrayValue___3rHoU {\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n}\n\n.EditableName___3OJ36 {\n  margin-left: 1rem;\n}\n\n.Invalid___1sVw9 {\n  background-color: var(--color-background-invalid);\n  color: var(--color-text-invalid) !important;\n}\n\n.Input___1SYGr:focus,\n.Invalid___1sVw9:focus {\n  background-color: var(--color-button-background-focus);\n}", ""]);

// exports
exports.locals = {
	"NewArrayValue": "NewArrayValue___3rHoU",
	"EditableName": "EditableName___3OJ36",
	"Invalid": "Invalid___1sVw9",
	"Input": "Input___1SYGr"
};